// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3f2tE","productName":"Table_productName__3H0ac"};